import api from "../../config/http-common";
import CommonUtil from "../../Util/CommonUtils";

const buildQuery = (filter) => {
    let query = "?pageNumber=" + filter.page + "&pageSize=" + filter.rowsPerPage;
  
    if (!CommonUtil.isEmptyString(filter.userName)) {
      query = query + "&userName=" + filter.userName;
    }
    if (!CommonUtil.isEmptyString(filter.module)) {
      query = query + "&module=" + filter.module;
    }
    if (!CommonUtil.isEmptyString(filter.subModule)){
      query = query + "&subModule=" + filter.subModule;
    }
    if (!CommonUtil.isEmptyString(filter.operationType)){
        query = query + "&operationType=" + filter.operationType;
    }
    if (!CommonUtil.isEmptyString(filter.operationDetails)){
        query = query + "&operationDetails=" + filter.operationDetails;
    }
    if (!CommonUtil.isEmptyString(filter.opResult)){
        query = query + "&opResult=" + filter.opResult;
    }
    return query;
  };

const get = (filter) => {
    return api.securedAxios().get("/web/operation_log" + buildQuery(filter));
};

const buildQueryCMD = (filter) => {
  let query = "?pageNumber=" + filter.page + "&pageSize=" + filter.rowsPerPage;
  if (!CommonUtil.isEmptyString(filter.commandId)) {
    query = query + "&commandId=" + filter.commandId;
  }
  if (!CommonUtil.isEmptyString(filter.deviceModel)) {
    query = query + "&deviceModel=" + filter.deviceModel;
  }
  if (!CommonUtil.isEmptyString(filter.deviceSn)){
    query = query + "&deviceSn=" + filter.deviceSn;
  }
  if (!CommonUtil.isEmptyString(filter.content)){
      query = query + "&content=" + filter.content;
  }
  if (!CommonUtil.isEmptyString(filter.remark)){
      query = query + "&remark=" + filter.remark;
  }
  if (!CommonUtil.isEmptyString(filter.returnedValue)){
      query = query + "&returnedValue=" + filter.returnedValue;
  }
  if (!CommonUtil.isEmptyString(filter.submitTimeFrom)) {
  query = query + "&submitTimeFrom=" + filter.submitTimeFrom;
  }
  if (!CommonUtil.isEmptyString(filter.submitTimeTo)) {
  query = query + "&submitTimeTo=" + filter.submitTimeTo;
  }
  if (!CommonUtil.isEmptyString(filter.returnFrom)) {
  query = query + "&returnFrom=" + filter.returnFrom;
  }
return query;
};

const getCMD = (filter) => {
  return api.securedAxios().get("/web/device/commands" + buildQueryCMD(filter));
};

const OperationLogService = {
  get,
  getCMD
};


export default OperationLogService;
